import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FETCH_INVOICES, UNSET_BOLD } from '../../redux/Invoices';
import Table from '../../components/Table/Table';
import InvoicesCell from '../Table/ButtonsCell/InvoicesCell/InvoicesCell';
import { truncateText } from '../../helpers/utils';
import { tablesHeaders } from '../../consts/tablesConf';

class InvoicesTableContainer extends PureComponent {
  static whichFolder = 'invoices';

  handleInvoiceView = (id) => {
    const isTextNotSelected = window.getSelection().toString() === '';
    if (isTextNotSelected) {
      const { unsetBold, invoices: { invoices } } = this.props;
      const invoicePreviewLink = invoices.find((item) => item.id === id).file_url;
      window.open(invoicePreviewLink, '_blank');
      unsetBold(id);
    }
  }

  handleDownloadClick = (e, id) => {
    const { unsetBold } = this.props;
    e.stopPropagation();
    unsetBold(id);
  }

  renderRow = (item) => {
    const { isMobile } = this.props;
    const formattedModelOrCategory = truncateText(get(item, 'model_or_category'), 13, 'right');

    const mobileCells = [
      <td key="mobile-cells" className="cell-mobile-wrapper">
        <div>
          <span>{get(item, 'display_number')}, {get(item, 'hash_id')}</span>
        </div>
        <div>
          <span>{get(item, 'brand')} {formattedModelOrCategory}</span>
        </div>
        <div>
          <span>{get(item, 'commission')}, {get(item, 'received_on')}</span>
        </div>
      </td>
    ];

    const desktopCells = [
      <td key="title">{get(item, 'display_number')}</td>,
      <td key="id" className="cell-owners">{get(item, 'hash_id')}</td>,
      <td key="brand">{get(item, 'brand')}</td>,
      <td key="model" className="cell-model">
        {formattedModelOrCategory}
      </td>,
      <td key="commission">{get(item, 'commission')}</td>,
      <td key="received_on">{get(item, 'received_on')}</td>,
      <td key="invoices_cell" className="cell-owners">
        <InvoicesCell
          url={get(item, 'file_url')}
          onDownloadClick={this.handleDownloadClick}
          id={get(item, 'id')}
        />
      </td>,
    ];

    return isMobile ? mobileCells : desktopCells
  }

  render() {
    const { invoices, fetchInvoices } = this.props;
    const { whichFolder } = InvoicesTableContainer;
    return (
      <Table
        whichFolder={whichFolder}
        tableHeaders={tablesHeaders['Motorbike'][whichFolder]}
        fetchOffers={fetchInvoices}
        totalCount={get(invoices, 'total_count')}
        totalPages={get(invoices, 'total_pages')}
        renderRow={this.renderRow}
        onRowClick={this.handleInvoiceView}
        items={get(invoices, 'invoices')}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    invoices: get(state, ['invoices']),
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoices: () => dispatch(FETCH_INVOICES()),
    unsetBold: id => dispatch(UNSET_BOLD({ id })),
  };
};

InvoicesTableContainer.propTypes = {
  fetchInvoices: PropTypes.func.isRequired,
  unsetBold: PropTypes.func.isRequired,
  invoices: PropTypes.shape({
    total_pages: PropTypes.number,
    total_count: PropTypes.number,
    invoices: PropTypes.object.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesTableContainer);
